import {ConfirmationDialog} from '@primer/react'
import {useCallback} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {unblockUserFromOrganization} from '../../mutations/unblock-user-from-organization-mutation'

type UnblockUserFromOrgDialogProps = {
  organization: {login: string; id: string}
  commentAuthor: {login: string; id: string}
  onClose: () => void
  contentId: string
}

export const UnblockUserFromOrgDialog = ({
  commentAuthor,
  organization,
  onClose,
  contentId,
}: UnblockUserFromOrgDialogProps) => {
  const environment = useRelayEnvironment()

  const onDialogClose = useCallback(
    (gesture: 'confirm' | 'cancel' | 'close-button' | 'escape') => {
      if (gesture === 'confirm') {
        unblockUserFromOrganization({
          environment,
          input: {unblockedUserId: commentAuthor.id, organizationId: organization.id},
          contentId,
        })
      }
      onClose()
    },
    [onClose, environment, commentAuthor.id, organization.id, contentId],
  )

  return (
    <ConfirmationDialog
      title={`Unblock ${commentAuthor.login} from ${organization.login}`}
      confirmButtonContent={'Unblock user'}
      confirmButtonType="danger"
      onClose={onDialogClose}
    >
      Are you sure you want to unblock <strong>{commentAuthor.login}</strong> from <strong>{organization.login}</strong>
      ?
    </ConfirmationDialog>
  )
}

try{ UnblockUserFromOrgDialog.displayName ||= 'UnblockUserFromOrgDialog' } catch {}